import React, { useEffect, useState, useContext } from "react";
import "./TechnicalSpecs2.css";

import tsImg from "../../../../assets/images/mhero2/ts.jpeg";

import { LanguageContext } from "../../../../context/LanguageContext";
import { getPageContent } from "../../../../api/publicContent.api";

const TechnicalSpecs2 = () => {
  const { currentLang } = useContext(LanguageContext);

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadContent = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await getPageContent("mhero2", currentLang);
        setData(response.sections?.technical_specs);
      } catch (err) {
        console.error("CMS load error:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    loadContent();
  }, [currentLang]);

  if (loading) return null;
  if (error || !data) return null;

  return (
    <section className="technical-specs">
      <h2 className="tech-title">{data.tech_title}</h2>

      <div className="spec-row">
        <div className="spec-left">
          <span className="spec-badge">{data.badge_overall}</span>

          <ul className="spec-list">
            <li>
              <span className="num">1</span> {data.overall_1_label}
              <span className="val">{data.overall_1_value}</span>
            </li>
            <li>
              <span className="num">2</span> {data.overall_2_label}
              <span className="val">{data.overall_2_value}</span>
            </li>
            <li>
              <span className="num">3</span> {data.overall_3_label}
              <span className="val">{data.overall_3_value}</span>
            </li>
            <li>
              <span className="num">4</span> {data.overall_4_label}
              <span className="val">{data.overall_4_value}</span>
            </li>
            <li>
              <span className="num">5</span> {data.overall_5_label}
              <span className="val">{data.overall_5_value}</span>
            </li>
          </ul>
        </div>

        <div className="spec-right">
          <img src={tsImg} alt="Overall dimensions" />
        </div>
      </div>

      <div className="spec-divider" />

      <div className="spec-row">
        <div className="spec-left">
          <span className="spec-badge">{data.badge_storage}</span>

          <ul className="spec-list">
            <li>
              <span className="num">1</span> {data.storage_1_label}
              <span className="val">{data.storage_1_value}</span>
            </li>
            <li>
              <span className="num">2</span> {data.storage_2_label}
              <span className="val">{data.storage_2_value}</span>
            </li>
          </ul>
        </div>

        <div className="spec-right">
          <img src={tsImg} alt="Storage" />
        </div>
      </div>

      <div className="spec-divider" />

      <div className="spec-row">
        <div className="spec-left">
          <span className="spec-badge">{data.badge_offroad}</span>

          <ul className="spec-list">
            <li>
              <span className="num">1</span> {data.offroad_1_label}
              <span className="val">{data.offroad_1_value}</span>
            </li>
            <li>
              <span className="num">2</span> {data.offroad_2_label}
              <span className="val">{data.offroad_2_value}</span>
            </li>
            <li>
              <span className="num">3</span> {data.offroad_3_label}
              <span className="val">{data.offroad_3_value}</span>
            </li>
            <li>
              <span className="num">4</span> {data.offroad_4_label}
              <span className="val">{data.offroad_4_value}</span>
            </li>
            <li>
              <span className="num">5</span> {data.offroad_5_label}
              <span className="val">{data.offroad_5_value}</span>
            </li>
            {data.rear_steer_label ? (
              <li>
                <span className="num">6</span> {data.rear_steer_label}
                <span className="val">{data.rear_steer_value}</span>
              </li>
            ) : null}
          </ul>
        </div>

        <div className="spec-right">
          <img src={tsImg} alt="Off-road specs" />
        </div>
      </div>
    </section>
  );
};

export default TechnicalSpecs2;
